import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { Geolocation } from './geolocation.models'

export const initGeolocation = createAction('[Geolocation] Init')

export const loadGeoLocation = createAction('[Geolocation/API] Load Geolocation')

export const loadGeolocationSuccess = createAction(
  '[Geolocation/API] Load Geolocation Success',
  props<{ geolocation: Geolocation }>(),
)

export const loadGeolocationFailure = createAction(
  '[Geolocation/API] Load Geolocation Failure',
  props<{ error: HttpErrorResponse }>(),
)
